import { GetStaticPropsContext } from 'next'

import FormElement from '@/components/form'
import { useMediumScreen } from '@/hooks/useMediaQuery'
import useOurTeam, { ourTeamInit } from '@/hooks/useOurTeam'
import Main from '@/layouts/main'
import EmployeeSection from '@/sections/rvdb/our-team/employees'
import OurTeamHeader from '@/sections/rvdb/our-team/header'
import {
  getOurTeamPageData,
  getRvdbNavigationData,
} from '@/services/contentful/api'
import { TeamOverview } from '@/interfaces/schema'
import PageProps from '@/interfaces/page'
import Snackbar from '@/components/snackbar'

const OurTeam = ({ data }: PageProps<TeamOverview>) => {
  const isMediumScreen = useMediumScreen()

  const { icon, title, filtersCollection, ctaCard } = data

  const {
    activeFilters,
    handleToggleFilters,
    handleCheckBoxChange,
    filteredEmployees,
    loading,
    errorMessage,
    isErrorSnackbarOpen,
    handleCloseErrorSnackbar,
    handleInputSearchQueryChange,
    handleSubmitSearch,
    handleLoadMore,
    totalCount,
  } = useOurTeam({
    filtersCollection,
  })

  return (
    <Main withGradient={isMediumScreen}>
      <FormElement
        initialValues={ourTeamInit}
        submitForm={handleSubmitSearch}
        wrapperClassName="w-full"
      >
        <OurTeamHeader
          icon={icon}
          title={title}
          handleInputSearchQueryChange={handleInputSearchQueryChange}
        />
        <EmployeeSection
          activeFilters={activeFilters}
          handleToggleFilters={handleToggleFilters}
          handleCheckBoxChange={handleCheckBoxChange}
          handleLoadMore={handleLoadMore}
          totalCount={totalCount}
          filteredEmployees={filteredEmployees}
          filtersCollection={filtersCollection}
          loadingContent={loading}
          ctaCard={ctaCard}
        />
        <Snackbar
          message={errorMessage}
          isOpen={isErrorSnackbarOpen}
          onClose={handleCloseErrorSnackbar}
        />
      </FormElement>
    </Main>
  )
}

export async function getStaticProps({ preview }: GetStaticPropsContext) {
  const isPreview: boolean = !!preview ?? false

  const { data: pageData, error: pageError } = await getOurTeamPageData(
    isPreview
  )
  const { data: navData, error: navError } = await getRvdbNavigationData(
    isPreview
  )

  return {
    props: {
      data: { navData, pageData },
      error: { pageError, navError },
    },
    revalidate: 60,
  }
}

export default OurTeam
